import React from 'react';
import fr from 'facet-rest';
import PropTypes from 'prop-types';
import { RightSidebarProvider } from 'Views/Page/Content/RightSidebar/RightSidebarContext';
import { useRoadmapPaths } from 'Components/UI/guidedHouseholdReview/pathsContext';
import Container from './container';

const LeversSidebarPicker = ({ onPickNewSize, setSaving }) => {
  const { pathResource, showGoals } = useRoadmapPaths();
  if (!pathResource || showGoals) {
    return null;
  }

  return pathResource.withRelationship(
    fr.relationships.levers.name,
    (rel) => (
      <RightSidebarProvider>
        <Container relationship={rel} onPickNewSize={onPickNewSize} setSaving={setSaving} />
      </RightSidebarProvider>
    ),
    () => null,
  );
};

LeversSidebarPicker.propTypes = {
  onPickNewSize: PropTypes.func.isRequired,
  setSaving: PropTypes.func.isRequired,
};

LeversSidebarPicker.defaultProps = {};

export default LeversSidebarPicker;
